// extracted by mini-css-extract-plugin
module.exports = {"countdown":"Ko-z","srOnly":"Lo-z"};